import { render } from "./NoPermission.vue?vue&type=template&id=23cd1ed4&scoped=true"
const script = {}

import "./NoPermission.vue?vue&type=style&index=0&id=23cd1ed4&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cd1ed4"]])

export default __exports__